/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ThirdPartyTicketCreateDto = {
    /**
     * Ticket identifier. Type: 'UUID'
     */
    uuid: string;
    /**
     * Logical number.
     */
    idLogicalNumber?: string;
    /**
     * Zone from which the ticket is valid.
     */
    zoneFrom: number;
    /**
     * Zone to which the ticket is valid.
     */
    zoneTo: number;
    /**
     * External ticket number.
     */
    ticketNumber: number;
    /**
     * Price of the ticket.
     */
    ticketPrice: number;
    /**
     * Number of passengers.
     */
    passengerCount: number;
    /**
     * VAT
     */
    vat: number;
    /**
     * Network identifier.
     */
    networkId: number;
    /**
     * Provider identifier.
     */
    providerId: number;
    /**
     * Whether ID validation is required.
     */
    idValidation: boolean;
    /**
     * Date from which the ticket is valid.
     */
    validFrom: string;
    /**
     * Date until which the ticket is valid.
     */
    validTo: string;
    /**
     * Type of the ticket.
     */
    type: ThirdPartyTicketCreateDto.type;
    /**
     * Customer profile number.
     */
    customerProfile: number;
    /**
     * Tariff profile number.
     */
    tariffProfile: number;
};
export namespace ThirdPartyTicketCreateDto {
    /**
     * Type of the ticket.
     */
    export enum type {
        SINGLE = 'SINGLE',
        COUPON = 'COUPON',
    }
}

